<template>
  <section id="welcome" class="overflow-hidden">
    <v-row no-gutters>
      <v-col cols="12" class="welcome-background"></v-col>

      <v-col class="pa-5" cols="12">
        <v-row align="center" justify="center">
          <v-col cols="12" md="8" lg="8">
            <heading tag="h1" class="display-1 mb-3">
              What is Virtual House Pro?
            </heading>
            <base-text class="body-1">
              Virtual House Pro helps take the guesswork out of the process and
              application of many of your home improvement needs! This is done
              by the use of an online personal consultant that is excited to
              guide and direct you along the way in a safe, unbiased, and
              comfortable environment!
            </base-text>
            <v-btn
              class="primary secondary--text rounded-md"
              to="schedule"
              x-large
            >
              Get Started
              <v-icon right>fa-angle-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import BaseText from "@/components/base/Text";
import Heading from "@/components/base/Heading";

export default {
  name: "Welcome",
  components: {
    BaseText,
    Heading,
  },
  data() {
    return {
      duration: 300,
      offset: 0,
      easing: "easeInOutCubic",
      stripe: null,
    };
  },
  computed: {
    target() {
      return "#scheduler";
    },
  },
  options() {
    return {
      duration: this.duration,
      offset: this.offset,
      easing: this.easing,
    };
  },
};
</script>

<style lang="scss" scoped>
.welcome-background {
  background-image: url("../assets/vhp_bkg@2x.jpg");
  background-size: cover;
  background-position: center center;
  position: relative;
  width: 100%;
  height: 28vh;

  @media (min-width: 768px) {
    height: 45vh;
  }

  .welcome-logo {
    position: absolute;
    top: 5%;
    left: 5%;
  }
}
</style>
